// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --brand-primary: 212 100% 47.06%; /* placeholder: current Kaizen blue #0070f0 */
    --brand-accent: 213 90.91% 95.69%; /* #EAF3FE */
}
`, "",{"version":3,"sources":["webpack://./src/frontend/@navigation/branding/brandTokens.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC,EAAE,6CAA6C;IAC/E,iCAAiC,EAAE,YAAY;AACnD","sourcesContent":[":root {\r\n    --brand-primary: 212 100% 47.06%; /* placeholder: current Kaizen blue #0070f0 */\r\n    --brand-accent: 213 90.91% 95.69%; /* #EAF3FE */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
